var _path, _path2, _g, _polygon, _polygon2, _polygon3, _path3, _path4, _path5, _path6, _polygon4, _polygon5, _path7, _path8, _line, _path9, _path10, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationEthernetCable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Ethernet cable",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252.9 180.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.5,25.99c5.58-6.47,13.42-7.61,17.36-7.71,15.86-.43,25.01,11.74,38.1,23.87,4.77,4.42,12.91,7.91,19.77,8.02,23.58.4,17.91-35.46,12.91-43.95,0,0,15.35-3.2,15.35-3.2,22.71,33.54-4.02,78.88-40.23,69.2-7.25-1.94-18.45-10.85-24.03-16.82-3.84-4.11-9.77-8.99-15.02-5.93l-24.19-23.49Z",
    fill: "#d1d1d1",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.36,6.95c3.61,7.92,6.23,25.96.23,36.26-3.19,5.47-8.27,8.18-15.12,8.07-6.96-.12-15.45-3.56-20.64-8.37-2.22-2.06-4.33-4.12-6.37-6.11-9.75-9.53-18.15-17.74-30.8-17.41-3.68.1-10.41,1.08-15.56,6.34l22.6,21.94c1.06-.47,2.16-.7,3.3-.7,3.71,0,7.88,2.45,12.44,7.33,5.33,5.69,16.43,14.58,23.41,16.44,14.88,3.98,29.32-1.45,38.62-14.52,9.02-12.67,12.64-33.55.66-51.93-1.33-2.93.34-2.76.34-2.76.52-.11,1.06.11,1.36.55,13.27,19.6,9.46,42.09-.21,55.67-7.81,10.98-19.02,16.92-31.19,16.92-3.36,0-6.8-.45-10.26-1.38-7.79-2.08-19.32-11.49-24.65-17.19-5.43-5.8-9.93-7.71-13.4-5.69-.51.3-1.16.22-1.58-.19l-24.19-23.49c-.5-.49-.54-1.28-.08-1.81,5.89-6.84,14.01-8.05,18.32-8.17,13.79-.36,22.53,8.22,32.71,18.16,2.03,1.98,4.12,4.03,6.32,6.06,4.68,4.34,12.63,7.56,18.89,7.67,5.79.1,10.13-2.18,12.8-6.76,6.09-10.45,2.26-29.58-1.05-35.2-.22-.37-.24-.81-.07-1.2.17-.39.52-.67.94-.76,1.58-.14,2.23,2.23,2.23,2.23Z",
    fill: "#4a4f57",
    stroke: "#464a53",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.78,51c0,14.67-11.89,23.37-26.55,19.44-14.67-3.93-26.55-19-26.55-33.67s11.89-23.37,26.55-19.44c14.67,3.93,26.55,19,26.55,33.67Z",
    fill: "#d52b1e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07,13.08c-5.3,0-10.17,1.57-14.16,4.62-5.64,4.32-8.74,11.09-8.74,19.06,0,16.03,13.01,32.56,28.99,36.84,8.18,2.2,16.13.91,21.95-3.56,5.64-4.32,8.74-11.09,8.74-19.06,0-16.3-12.73-32.49-28.99-36.84-2.66-.71-5.28-1.07-7.8-1.07ZM141.93,68.09c-1.94,0-3.97-.28-6.06-.83-13.3-3.56-24.12-17.24-24.12-30.49,0-5.87,2.19-10.79,6.17-13.84,4.17-3.2,10.05-4.08,16.25-2.42,13.3,3.56,24.12,17.24,24.12,30.49,0,5.87-2.19,10.79-6.17,13.84-2.81,2.16-6.31,3.26-10.19,3.26Z",
    fill: "#4a4f57",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.63,60.76c0,14.67-11.89,23.37-26.55,19.44-14.67-3.93-26.55-19-26.55-33.67s11.89-23.37,26.55-19.44c14.67,3.93,26.55,19,26.55,33.67Z",
    fill: "#d52b1e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.31,22.85c-5.3,0-10.17,1.57-14.16,4.62-5.64,4.32-8.74,11.09-8.74,19.06,0,16.03,13.01,32.56,28.99,36.84,8.18,2.2,16.13.91,21.95-3.56,5.64-4.32,8.74-11.09,8.74-19.06,0-16.3-12.73-32.49-28.99-36.84-2.66-.71-5.28-1.07-7.8-1.07ZM132.16,77.86c-1.94,0-3.97-.28-6.06-.83-13.3-3.56-24.12-17.24-24.12-30.49,0-5.87,2.19-10.79,6.17-13.84,4.17-3.2,10.05-4.08,16.25-2.42,13.3,3.56,24.12,17.24,24.12,30.49,0,5.87-2.19,10.79-6.17,13.84-2.81,2.16-6.31,3.26-10.19,3.26Z",
    fill: "#4a4f57",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M141.62,70.95c0,14.67-11.89,23.37-26.55,19.44-14.67-3.93-26.55-19-26.55-33.67s11.89-23.37,26.55-19.44c14.67,3.93,26.55,19,26.55,33.67Z",
    fill: "#d52b1e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,33.04c-5.3,0-10.17,1.57-14.16,4.62-5.64,4.32-8.74,11.09-8.74,19.06,0,16.03,13.01,32.56,28.99,36.84,8.18,2.2,16.13.91,21.95-3.56,5.64-4.32,8.74-11.09,8.74-19.06,0-16.3-12.73-32.49-28.99-36.84-2.66-.71-5.28-1.07-7.8-1.07ZM121.98,88.05c-1.94,0-3.97-.28-6.06-.83-13.3-3.56-24.12-17.24-24.12-30.49,0-5.87,2.19-10.79,6.17-13.84,4.17-3.2,10.05-4.08,16.25-2.42,13.3,3.56,24.12,17.24,24.12,30.49,0,5.87-2.19,10.79-6.17,13.84-2.81,2.16-6.31,3.26-10.19,3.26Z",
    fill: "#4a4f57",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "129.3 52.19 114.45 48.2 137.89 26.86 145.95 35.97 129.3 52.19",
    fill: "#d52b1e",
    strokeWidth: 0
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "102.51 117.8 3.77 91.34 61.97 39.13 150.44 62.9 102.51 117.8",
    fill: "#35c0e2",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.99 173.21 3.77 146.16 3.77 92.23 102.51 118.69 101.99 173.21",
    fill: "#35c0e2",
    strokeWidth: 0
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "152.42 116.57 102.59 176.79 102.59 118.04 149.99 63.43 152.42 116.57",
    fill: "#35c0e2",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.09,156.19v-38.64c0-1.07-.87-1.94-1.94-1.94s-1.94.87-1.94,1.94v33.97l3.87,1.07",
    fill: "#4a4f57",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.67,167.5v-35.45c0-1.07-.87-1.94-1.94-1.94s-1.94.87-1.94,1.94v34.37l3.89,1.08",
    fill: "#4a4f57",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.59,161.58v-34.31c0-1.07.87-1.94,1.94-1.94s1.94.87,1.94,1.94v35.3l-3.89-.99Z",
    fill: "#4a4f57",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.29,157.55l-3.89-1.08v-34.1c0-1.07.87-1.94,1.94-1.94s1.94.87,1.94,1.94v38.7",
    fill: "#4a4f57",
    strokeWidth: 0
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.44 61.54 150.44 119.73 102.78 176.81 102.78 118.06 150.44 61.54",
    fill: "none",
    stroke: "#4a4f57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "62.92 37.57 3.5 91.12 102.78 118.15 150.44 60.9 62.92 37.57",
    fill: "none",
    stroke: "#4a4f57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.84,18.86l-34.57,50.67s18.23,24.03-18.36,39.61l-34.72-9.06c-10.49-27.2,28.44-38.35,28.44-38.35L108.38,13.95l19.45,4.92Z",
    fill: "#35c0e2",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.6,18.57c-.39-1.02-1.25-1.79-2.31-2.06l-19.46-4.92c-.27-.07-.54-.1-.81-.1-.99,0-1.94.43-2.58,1.21l-39.08,46.98-.22.06c-5.09,1.52-22.23,7.48-28.83,20.28-3.3,6.39-3.5,14.66-.61,22.16.37.96,1.19,1.72,2.17,2.01l34.73,9.06c.74.22,1.56.17,2.26-.13,13.55-5.77,21.68-13.43,24.16-22.76,2.23-8.41-.84-15.81-2.87-19.48l-.22-.4,33.32-48.84c.62-.9.75-2.05.37-3.08ZM90.13,68.53c-.8,1.18-.77,2.75.09,3.91.05.07,5.61,7.73,3.29,16.28-1.87,6.91-8.24,12.84-18.93,17.64l-.25.11-31.92-8.23-.12-.39c-1.49-4.94-1.18-10.58.96-14.74,6.23-12.09,25.64-17.19,25.84-17.24.69-.18,1.3-.56,1.75-1.1l38.4-46.17,12.76,3.23-31.87,46.7Z",
    fill: "#4a4f57",
    strokeWidth: 0
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 113.94,
    y1: 52.25,
    x2: 96.91,
    y2: 70.48,
    fill: "#00bce4",
    stroke: "#454a52",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5,169.74l12.23,3.33c1.46.44,2.25-.28,2.56-.68l.16-.24h0s3.13-4.74,3.13-4.74l-18.08-4.92v7.25Z",
    fill: "#4a4f57",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,164.8l13.23,3.6c.82-.06,1.3-.52,1.53-.81l.16-.24h0s3.21-4.87,3.21-4.87l-18.14-4.94v7.25Z",
    fill: "#4a4f57",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.12,159.84l13.26,3.61c.86-.03,1.36-.52,1.59-.82l.16-.24h0s3.2-4.85,3.2-4.85l-18.21-4.96v7.25Z",
    fill: "#4a4f57",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.68,114.68L4.4,88.22c-1.05-.28-2.17-.06-3.03.61C.51,89.49,0,90.51,0,91.6v58.18c0,1.58,1.06,2.96,2.58,3.38l19.63,5.34c.81-.06,1.3-.52,1.53-.81l.16-.24h0s3.21-4.87,3.21-4.87l-20.11-5.47v-50.95l92.28,24.59v51.48l-17.61-4.79v7.25l20.19,5.5c.3.08.61.12.92.12.76,0,1.51-.25,2.12-.72.87-.66,1.38-1.69,1.38-2.78v-58.75c0-1.59-1.07-2.97-2.6-3.38Z",
    fill: "#4a4f57",
    strokeWidth: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEthernetCable);
export default __webpack_public_path__ + "static/media/Illustration-Ethernet-Cable.e7700720519354d8e32751050eb5d3ab.svg";
export { ForwardRef as ReactComponent };